module.exports = __webpack_public_path__ + "img/01-1数字化产线.39f3046f.png";